import React, {RefObject} from "react";
import "./Dictation.scss";
import TasksSection from "../TasksSection/TasksSection";
import Navigation from "../Navigation/Navigation";

interface OwnProps {
    headerReference: RefObject<HTMLDivElement>
}

const Dictation: React.FC<OwnProps> = (props: OwnProps): React.ReactElement => {
    const {headerReference}: OwnProps = props;
    return (
        <div className="df-dictation-content">
            <div className="df-main-content">
                <Navigation/>
                <TasksSection headerReference={headerReference}/>
            </div>
        </div>
    );
};

export default Dictation;
